<template>
    <div>
        <div v-for="(sitem, sindex) in info.children" :key="sindex">
            <div class="test_info flex Flexalign FlexBetween">
                <div class="test_info_left flex Flexalign">
                    <!-- <div class="cursor_pointer" v-if="!sitem.showDetail" @click="changeDetailShow(sitem, true)">
                        <el-icon color="RGBA(162, 162, 162, 1)" :size="18">
                            <ArrowDown />
                        </el-icon>
                    </div>
                    <div class="cursor_pointer" v-else @click="changeDetailShow(sitem, false)">
                        <el-icon color="RGBA(162, 162, 162, 1)" :size="18">
                            <ArrowUp />
                        </el-icon>
                    </div> -->
                    <div class="test_name">章节测试-{{ sitem.chapterName }}</div>
                    <!-- <div class="test_deadline">截止时间：{{ sitem.deadline }}</div> -->
                </div>
                <div class="test_info_right flex Flexalign">
                    <div class="test_score" v-if="sitem.isTest">得分：<span class="score_value">{{
                        sitem.score }}</span>分
                    </div>
                    <div class="btn_test cursor_pointer" v-if="sitem.examId" @click="testBegin(sitem)">开始测验
                    </div>
                </div>
            </div>
            <!-- <div class="test_detail" v-if="sitem.showDetail">
                <div class="test_score_info">
                    共{{ sitem.totalTopic }}
                                道选择题，每题{{ sitem.eachScore }}分，
                    共{{ sitem.fullScore }}分
                </div>
                <div class="test_detail_one flex Flexalign">
                                <div class="test_label">截止时间</div>
                                <div>{{ sitem.deadline }}</div>
                            </div>
                <div class="test_detail_one flex Flexalign test_attention">
                                <div class="test_label"></div>
                                <div>请务必在截止时间之前提交，截止时间后的提交不再计分</div>
                            </div>
                <div class="test_detail_one flex Flexalign">
                                <div class="test_label">有效分数</div>
                                <div><span class="active_score">{{ sitem.score }}</span>/<span>{{ sitem.totalScore
                                        }}</span>
                                </div>
                            </div>
                <div class="test_detail_one flex Flexalign test_attention">
                                <div class="test_label"></div>
                                <div>你的每一次测验系统都将为你计分，并提取最高得分作为你的有效分数</div>
                            </div>
                            <div class="test_detail_one flex Flexalign">
                                <div class="test_label">有效提交次数</div>
                                <div><span class="active_score">{{ sitem.submitNumber }}</span>/<span>{{
                                    sitem.totalSubmitNumber
                                        }}</span></div>
                            </div>
                            <div class="test_detail_one flex Flexalign test_attention">
                                <div class="test_label"></div>
                                <div>最多可以进行3次测验，取最高分记录成绩</div>
                            </div>
                <div class="history_test" v-if="item.historyTest.length">
                            <div class="history_test_top flex Flexalign">
                                <div class="test_num">次数</div>
                                <div class="test_time">测试时间</div>
                                <div class="test_score">得分</div>
                                <div class="test_action flex-1">操作</div>
                            </div>
                            <div class="history_test_top flex Flexalign history_test_content"
                                v-for="(sitem, sindex) in item.historyTest" :key="sindex">
                                <div class="test_num">{{ sitem.index }}</div>
                                <div class="test_time">{{ sitem.testTime }}</div>
                                <div class="test_score">{{ sitem.score }}</div>
                                <div class="test_action flex-1 test_look cursor_pointer">查看</div>
                            </div>
                        </div>
            </div> -->

            <div v-if="sitem?.children">
                <TreeChild :info="sitem" @changeDetailShow="changeDetailShow" @testBegin="testBegin">
                </TreeChild>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'GjkcH5TreeChild',
    props: {
        info: {},
    },

    data() {
        return {

        };
    },

    mounted() {
        
    },

    methods: {
        changeDetailShow(info,flag){
            this.$emit('changeDetailShow',info,flag)
        },
        testBegin(info){
            this.$emit('testBegin',info)
        },
    },
};
</script>

<style lang="scss" scoped>
.test_info {
    margin-top: 15px;
    width: 721px;
    height: 56px;
    background: #F8F9FB;
    border-radius: 10px;
    padding: 0 20px;
    box-sizing: border-box;

    .test_name {
        // font-weight: 600;
        color: #333333;
        margin: 0 15px 0 10px;
    }

    .test_deadline {
        font-size: 14px;
        color: #999999;
    }

    .test_info_right {
        .test_score {
            font-size: 14px;
            color: #999999;

            .score_value {
                color: RGBA(93, 221, 188, 1);
            }
        }

        .btn_test {
            width: 90px;
            height: 32px;
            // background: linear-gradient(90deg, #00D5C2, #00D498);
            border-radius: 16px;
            line-height: 32px;
            text-align: center;
            color: #13d6aa;
            margin-left: 20px;
            font-weight: normal;
            font-size: 16px;
        }
    }
}
</style>